// src/redux/promotedVendorsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { userRequest } from "../api/requestMethods";

export const fetchPromotedVendors = createAsyncThunk(
    "promotedVendors/fetchPromotedVendors",
    async (_, { rejectWithValue }) => {
        try {
            const response = await userRequest.get("/rw/promoted-vendors");
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Fetches ALL active vendors (promoted or not) — used by AllVendorsPage
export const fetchAllActiveVendors = createAsyncThunk(
    "promotedVendors/fetchAllActiveVendors",
    async (_, { rejectWithValue }) => {
        try {
            const response = await userRequest.get("/rw/all-active-vendors");
            return response.data.vendors;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const promotedVendorsSlice = createSlice({
    name: "promotedVendors",
    initialState: {
        promotedVendors: [],
        allVendors: [],
        isFetching: false,
        isFetchingAll: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPromotedVendors.pending, (state) => {
                state.isFetching = true;
            })
            .addCase(fetchPromotedVendors.fulfilled, (state, action) => {
                state.promotedVendors = action.payload.promotedVendors;
                state.isFetching = false;
                state.error = null;
            })
            .addCase(fetchPromotedVendors.rejected, (state, action) => {
                state.error = action.payload;
                state.isFetching = false;
            })
            .addCase(fetchAllActiveVendors.pending, (state) => {
                state.isFetchingAll = true;
            })
            .addCase(fetchAllActiveVendors.fulfilled, (state, action) => {
                state.allVendors = action.payload;
                state.isFetchingAll = false;
                state.error = null;
            })
            .addCase(fetchAllActiveVendors.rejected, (state, action) => {
                state.error = action.payload;
                state.isFetchingAll = false;
            });
    },
});

export default promotedVendorsSlice.reducer;
